import {Routes} from '@angular/router';
import {AdminComponent} from './admin/admin.component';
import authRoutes from './site/auth/auth.routes';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./site/home/home.component').then(m => m.HomeComponent),
  },
  ...authRoutes,
  {
    path: 'admin',
    component: AdminComponent,
    loadChildren: () => import('./admin/admin.routes'),
  },
];
